// Angular
import { Component, OnInit } from '@angular/core';
// Models
import { Tournament } from './../../models/tournament';
// Services

import { ApiService } from './../../services/api';
import * as lodash from 'lodash';
import { OAuthService } from './../../services/o-auth';
import { Club } from './../../models/club'
import { AngularFireDatabase } from 'angularfire2/database';
import { ElasticService } from 'app/services/elastic';
import * as moment from 'moment';
import * as Chart from 'chart.js'

@Component({
  templateUrl: './community-dashboard.component.html'
})
export class CommunityDashboardComponent implements OnInit {
  public user
  public ranges = []
  public users = []
  public search = {
    range: 1,
    user: 1
  }
  revenueChart: any;
  canvas
  ctx
  count = 0
  label = ""
  constructor(private fireDatabase: AngularFireDatabase, private oAuthService: OAuthService, private apiService: ApiService, private elasticService: ElasticService) {

  }



  async ngOnInit() {
    this.user = this.oAuthService.getClub()
    this.canvas = document.getElementById('revenueChart');
    if (this.canvas) {
      this.ctx = this.canvas.getContext('2d');
      this.revenueChart = new Chart(this.ctx, {
        type: 'bar',
        options: {
          responsive: true
        }
      });
    }

    this.ranges.push({ name: "1 day", key: "Hour", value: -1 })
    this.ranges.push({ name: "1 week", key: "Day", value: 0 })
    this.ranges.push({ name: "This month", key: "Date", value: 1 })
    this.ranges.push({ name: "Last 3 months", key: "Date-Month", value: 2 })
    this.ranges.push({ name: "Last 6 months", key: "Date-Month", value: 3 })
    this.ranges.push({ name: "Last 1 year", key: "Month", value: 4 })
    this.ranges.push({ name: "Last 2 year", key: "Month-Year", value: 5 })
    this.ranges.push({ name: "Last 3 year", key: "Month-Year", value: 6 })

    this.users.push({ name: "All Users", value: 1, key: "user" })
    this.users.push({ name: "Amateurs", value: 2, key: "user" })
    this.users.push({ name: "Pros", value: 3, key: "user" })
    this.users.push({ name: "Clubs", value: 4, key: "club" })
    this.users.push({ name: "Companies", value: 5, key: "company" })
    this.users.push({ name: "Societies", value: 6, "key": "society" })
    this.users.push({ name: "Tours", value: 7, key: "tour" })

    this.onSearchChange()
  }



  getSingleData(type, range) {
    let promise = new Promise(async (resolve, reject) => {
      let clubsCount
      clubsCount = {
        'index': 'users',
        'type': type,
        'body/query/range/createdAt/gte': range.gte,
        'body/query/range/createdAt/lte': range.lte,
      };

      if (this.search.user == 2) {
        clubsCount = {
          'index': 'users',
          'type': 'user',
          'body/query/bool/must/range/createdAt/gte': range.gte,
          'body/query/bool/must/range/createdAt/lte': range.lte,
        };
        clubsCount['body/query/bool/filter/term/isPro'] = false

      }
      if (this.search.user == 3) {
        clubsCount = {
          'index': 'users',
          'type': 'user',
          'body/query/bool/must/range/createdAt/gte': range.gte,
          'body/query/bool/must/range/createdAt/lte': range.lte,
        };
        clubsCount['body/query/bool/filter/term/isPro'] = true

      }

      let result = await this.elasticService.search(clubsCount)

      resolve(result)
    })
    return promise
  }


  async getData(type, range) {
    let ranges = this.getRange(range).intervals
    let now = new Date().getTime()
    let promises = []

    for (let r = 0; r < ranges.length; r++) {
      const element = ranges[r];

      promises.push(this.getSingleData(type, element))
    }
    let datas = await Promise.all(promises)
    let label = []
    let data = []
    let format = this.getFormat(range)
    this.count = 0
    for (let d = 0; d < datas.length; d++) {
      const da = datas[d];
      let gte = moment.unix(ranges[d].gte).format(format)
      let lte = moment.unix(ranges[d].lte).format(format)
      if (da) {
        data.push(da.total)
        this.count = this.count + da.total
      } else {
        data.push(0)
      }
      label.push(lte)

    }

    if (this.revenueChart) {
      this.revenueChart.destroy();
      this.revenueChart = new Chart(this.ctx, {
        type: 'line',
        data: {
          labels: label.reverse(),
          datasets: [{
            label: 'User',
            data: data.reverse(),
            backgroundColor: 'rgba(79, 184, 96, 1)',
            fill: false,
            borderWidth: 1,
            borderColor: 'rgba(79, 184, 96, 1)',
            showLine: true,
          }]
        },
        options: {
          responsive: true,
          animation: {
            duration: 0 // general animation time
          },
          hover: {
            animationDuration: 0 // duration of animations when hovering an item
          },
          responsiveAnimationDuration: 0, // animation duration after a resize,
          elements: {
            line: {
              tension: 0 // disables bezier curves
            }
          },
          legend: {
            display: false
          },
          scales: {

            xAxes: [
              {
                ticks: {
                  fontColor: "#4fb860",

                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  fontColor: "#4fb860",

                }
              }
            ]
          }
        }
      });
      this.revenueChart.update();
    }

    let then = new Date().getTime()
    console.log(then - now)
  }

  getFormat(type) {
    type = parseInt(type + "")

    switch (type) {
      case -1: //this day
        return "HH"

      case 0: //this week
        return "dd"

      case 1: //this month
        return "DD"

      case 2://last 3 month
        return "DD-MM"

      case 3://last 6 month
        return "DD-MM"


      case 4://last 1 year
        return "MMM"

      case 5://last 2 year
        return "MM-YY"


      case 6://last 5 year
        return "MM-YY"


    }
  }

  getRange(type) {
    type = parseInt(type + "")
    let lte = moment().unix()
    let gte = moment().date(1).unix()
    let intervals = []
    switch (type) {
      case -1: //this day
        let lgte = moment()
        gte = moment().subtract(24, "h").unix()

        for (let i = 1; i <= 24; i++) {
          lgte = moment().subtract(i, 'h')
          let gte = lgte.unix()
          let lte = lgte.add(1, 'h').unix()
          intervals.push({
            gte: gte,
            lte: lte
          })
        }

        break
      case 0: //this week
        gte = moment().subtract(1, "w").unix()
        for (let i = 1; i <= 7; i++) {
          lgte = moment().subtract(i, 'd')
          let gte = lgte.unix()
          let lte = lgte.add(1, 'd').unix()
          intervals.push({
            gte: gte,
            lte: lte
          })
        }
        break
      case 1: //this month
        gte = moment().date(1).hour(0).minute(0).unix()
        let diff = new Date().getDate()
        for (let i = 1; i <= diff; i++) {
          lgte = moment().subtract(i, 'd')
          let gte = lgte.unix()
          let lte = lgte.add(1, 'd').unix()
          intervals.push({
            gte: gte,
            lte: lte
          })
        }
        break
      case 2://last 3 month
        gte = moment().subtract(3, "M").unix()
        for (let i = 1; i <= 12; i++) {
          lgte = moment().subtract(i, 'w')
          let gte = lgte.unix()
          let lte = lgte.add(1, 'w').unix()
          intervals.push({
            gte: gte,
            lte: lte
          })
        }
        break
      case 3://last 6 month
        gte = moment().subtract(6, "M").unix()
        for (let i = 1; i <= 24; i++) {
          lgte = moment().subtract(i, 'w')
          let gte = lgte.unix()
          let lte = lgte.add(1, 'w').unix()
          intervals.push({
            gte: gte,
            lte: lte
          })
        }
        break
      case 4://last 1 year
        gte = moment().subtract(1, "y").unix()
        for (let i = 1; i <= 12; i++) {
          lgte = moment().subtract(i, 'M')
          let gte = lgte.unix()
          let lte = lgte.add(1, 'M').unix()
          intervals.push({
            gte: gte,
            lte: lte
          })
        }
        break
      case 5://last 2 year
        gte = moment().subtract(2, "y").unix()
        for (let i = 1; i <= 12; i++) {
          lgte = moment().subtract(i * 2, 'M')
          let gte = lgte.unix()
          let lte = lgte.add(2, 'M').unix()
          intervals.push({
            gte: gte,
            lte: lte
          })
        }
        break
      case 6://last 5 year
        gte = moment().subtract(5, "y").unix()


        for (let i = 1; i <= 15; i++) {
          lgte = moment().subtract(i, 'Q')
          let gte = lgte.unix()
          let lte = lgte.add(1, 'Q').unix()
          intervals.push({
            gte: gte,
            lte: lte
          })
        }
        break
    }

    return { gte, lte, intervals }
  }
  async onSearchChange() {
    let type = this.users.find(u => u.value == this.search.user)
    let range = this.ranges.find(r => r.value == this.search.range)
    this.label = range.key
    await this.getData(type.key, this.search.range)
  }

  onUserChange(event) {
    this.search.user = parseInt(event + "")
    this.onSearchChange()
  }
  onRangeChange(event) {
    this.search.range = parseInt(event + "")
    this.onSearchChange()

  }
}




